/* eslint-disable */
function handleScroll() {
  const header = $('.header');
  $(window).on('scroll', function () {
    header[window.pageYOffset > 60 ? 'addClass' : 'removeClass'](
      'header--shrinked'
    );
  });
}

function initMenu() {
  $('.hamburger').on('click', function () {
    $('.nav').toggleClass(['-translate-y-full', 'translate-y-0', 'opacity-0']);
    $('html').toggleClass('overflow-hidden');
  });
}

export default function menu() {
  handleScroll();
  initMenu();
}
